/**
 * Created by Andrey Popov on 10/7/25.
 */

const PathBubbleView = cc.Sprite.extend({
    ctor: function (unit, options) {
        this._super(bundles.path_sign.frames.target_bubble);
        this.unit = unit;

        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.PathBubbleView;

        const pathBubbleArrow = this.pathBubbleArrow = new cc.Sprite(bundles.path_sign.frames.target_bubble_corner);
        pathBubbleArrow.setAnchorPoint(0.5, 0.5);
        this.addChild(pathBubbleArrow);

        const targetSign = new cc.Sprite(bundles.path_sign.frames.target);
        this.addChild(targetSign);
        targetSign.setAlignment(this.width / 2, this.height / 2);

        if (options.checkmark) {
            const checkmark = new cc.Sprite(bundles.customer_check_marks.frames.customer_check_mark);
            checkmark.setAlignment(styles.checkmark);
            this.addChild(checkmark);
        }

        this.setCascadeOpacityEnabledRecursively(true);

        cleverapps.UI.applyHover(this);
        cleverapps.UI.onClick(this, options.onClick);

        cleverapps.Scenes.GetRunningScene().addChild(this);
        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER - 1);

        this.checkTargetUnitVisibility();

        cleverapps.eventBus.on("openWindow", this.createListener(this.checkTargetUnitVisibility.bind(this)), this);
        cleverapps.eventBus.on("closeWindows", this.createListener(this.checkTargetUnitVisibility.bind(this)), this);

        const customers = Map2d.currentMap && Map2d.currentMap.customers;
        if (customers) {
            customers.on("selectedCustomerChanged", this.createListener(this.checkTargetUnitVisibility.bind(this)), this);
        }

        this.showUp();
    },

    showUp: function () {
        this.setBubblePosition();

        this.setOpacity(0);
        this.runAction(new cc.FadeIn(0.1));
    },

    hide: function (silent) {
        if (this.isRunning()) {
            if (silent) {
                this.removeFromParent();
            } else {
                this.runAction(new cc.Sequence(
                    new cc.FadeOut(0.1),
                    new cc.RemoveSelf()
                ));
            }
        }
    },

    setBubblePosition: function () {
        const styles = cleverapps.styles.PathBubbleView;
        const screenSize = cleverapps.resolution.getSceneSize();
        const w = screenSize.width, h = screenSize.height;

        const centerCell = Map2d.currentMap.getScreenCenterCell();
        const c = Map2dInnerView.IsoToScreen(centerCell.x, centerCell.y);
        const t = Map2dInnerView.IsoToScreen(this.unit.x, this.unit.y);

        const dx = t.x - c.x;
        const dy = t.y - c.y;

        const s = Math.min((w * 0.5) / Math.max(Math.abs(dx), 1), (h * 0.5) / Math.max(Math.abs(dy), 1));
        let px = (w * 0.5) + dx * s;
        let py = (h * 0.5) + dy * s;

        const scale = connector.info.isMobile || cleverapps.resolution.isVertical()
            ? styles.mobileScale[cleverapps.resolution.mode] : 1;

        this.setScale(scale);
        this.baseScale = scale;

        const padX = this.width * 0.5 * scale;
        const padY = this.height * 0.5 * scale;

        const adjusted = this.adjustPositionToMargins(cc.p(px, py));
        px = adjusted.x;
        py = adjusted.y;

        const minX = padX;
        const maxX = w - padX;
        const minY = padY;
        const maxY = h - padY;
        if (px < minX) {
            px = minX;
        }
        if (px > maxX) {
            px = maxX;
        }
        if (py < minY) {
            py = minY;
        }
        if (py > maxY) {
            py = maxY;
        }

        this.setAlignment(px, py);

        const offX = (px - w * 0.5) / w;
        const offY = (py - h * 0.5) / h;
        let dir;
        if (Math.abs(offX) >= Math.abs(offY)) {
            dir = offX >= 0 ? 1 : 3;
        } else {
            dir = offY >= 0 ? 0 : 2;
        }
        this.pathBubbleArrow.setAlignment(styles.arrow[dir]);
        this.pathBubbleArrow.setRotation(90 * dir);
    },

    checkTargetUnitVisibility: function () {
        const customers = Map2d.currentMap && Map2d.currentMap.customers;
        const isCustomerSelected = customers && customers.selectedCustomer && customers.selectedCustomer.unit === this.unit;
        const isVisible = !isCustomerSelected
            && !Map2d.currentMap.isScreenCellPosition(this.unit.x, this.unit.y)
            && cleverapps.focusManager.currentWindow() === undefined;
        if (isVisible) {
            this.setBubblePosition();
        }
        this.setVisible(isVisible);
    },

    adjustPositionToMargins: function (p) {
        const styles = cleverapps.styles.PathBubbleView;
        const screenSize = cleverapps.resolution.getSceneSize();
        const margins = cleverapps.resolution.isVertical() ? styles.verticalMargins : styles.margins;

        if (p.y > screenSize.height - margins.top) {
            p.y = screenSize.height - margins.top;
        } else if (p.y < margins.bottom) {
            p.y = margins.bottom;
        }

        if (p.x < margins.left) {
            p.x = margins.left;
        } else if (p.x > screenSize.width - margins.right) {
            p.x = screenSize.width - margins.right;
        }

        return cc.p(p.x, p.y);
    }
});

cleverapps.styles.PathBubbleView = {
    arrow: [
        { // top
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 12 }
        },
        { // right
            x: { align: "right", dx: 22 },
            y: { align: "center", dy: 0 }
        },
        { // bottom
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -8 }
        },
        { // left
            x: { align: "left", dx: -21 },
            y: { align: "center", dy: 0 }
        }
    ],

    margins: {
        top: 164,
        right: 292,
        bottom: 194,
        left: 292
    },

    verticalMargins: {
        top: 130,
        right: 200,
        bottom: 140,
        left: 200
    },

    mobileScale: [0.75, 1, 1],

    checkmark: {
        x: { align: "right", dx: -6 },
        y: { align: "bottom", dy: 6 }
    }
};